"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_SelectOption = exports.Occ_SelectIcon = exports.Occ_SelectContainer = exports.Occ_Select = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_SelectContainer = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: var(--spacing-none);\n    margin: var(--spacing-none);\n    font-family: var(--font-family-primary);\n    position: relative;\n    width: ", ";\n    opacity: ", ";\n    pointer-events: ", ";\n"])), function (props) {
  if (props.size === 'small') {
    return '150px';
  } else if (props.size === 'medium') {
    return '200px';
  } else if (props.size === 'large') {
    return '250px';
  } else if (props.size === 'full') {
    return '100%';
  }
}, function (props) {
  if (props.disabled) {
    return 'var(--opacity-50)';
  } else {
    return 'var(--opacity-100)';
  }
}, function (props) {
  if (props.disabled) {
    return 'none';
  } else {
    return 'all';
  }
});
exports.Occ_SelectContainer = Occ_SelectContainer;
var Occ_Select = (0, _styledComponents["default"])('select')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    -webkit-appearance: none;\n    font-size: var(--font-size-xs);\n    background-color: ", ";\n    border-top-left-radius: var(--border-radius-xs);\n    border-top-right-radius: var(--border-radius-xs);\n    transition: all 0.1s ease-in-out;\n    border: transparent;\n    height: 50px;\n    padding: 8px 5px;\n    width: 100%;\n\n    &:focus {\n        outline: transparent;\n        border-bottom: 1px solid var(--color-primary);\n        color: var(--color-primary-highlight);\n    }\n"])), function (props) {
  if (props.backgroundColor === 'gray') {
    return 'var(--color-gray-200)';
  } else if (props.backgroundColor === 'white') {
    return 'var(--color-base-white)';
  } else {
    return 'darkred';
  }
});
exports.Occ_Select = Occ_Select;
var Occ_SelectOption = (0, _styledComponents["default"])('option')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: var(--color-base-black);\n"])));
exports.Occ_SelectOption = Occ_SelectOption;
var Occ_SelectIcon = (0, _styledComponents["default"])('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 5px;\n    top: 10px;\n    pointer-events: none;\n"])));
exports.Occ_SelectIcon = Occ_SelectIcon;